import { GET_NOTES, NEW_NOTE, UPDATE_NOTE, DELETE_NOTE, RESET_NOTES } from '../types';

const excerptLen = 80; // Number of characters in excerpt

export default function (notes = [], action) {
  switch (action.type) {
    case GET_NOTES:
      return getNotes(action.payload);
    case UPDATE_NOTE:
      return updateNotes(notes, action.payload);
    case NEW_NOTE:
      return newNote(notes, action.payload);
    case DELETE_NOTE:
      return deleteNote(notes, action.payload);
    case RESET_NOTES:
      return [];
    default:
      return notes;
  }
}

function getNotes(payload) {
  const res = payload;
  if (res.status && res.status === 200) {
    const data = res.data.map(note => {
      return { ...note, excerpt: getExcerpt(note.content), saved: true } 
    });
    return sortNotesByTitle(data);
  } else {
    return [];
  }
}

function updateNotes(notes, payload) {
  const updatedNotes = [ ...notes.filter(note => note.id !== payload.id), { ...payload, excerpt: getExcerpt(payload.content) } ];
  return sortNotesByTitle(updatedNotes);
}

function newNote(notes, payload) {
  return sortNotesByTitle([ ...notes.filter(note => note.title !== payload.title || note.saved), { ...payload, excerpt: getExcerpt(payload.content) } ]);
}

function deleteNote(notes, id) {
  return sortNotesByTitle(notes.filter(note => note.id !== id));
}

function getExcerpt(content) {
  let note = content;
  try {
    const parsed = JSON.parse(content);
    note = '';
    const len = parsed.blocks.length;
    let i = 0;
    while(i < 3 && i < len) {
      note += parsed.blocks[i].text + ' ';
      i++;
    }
  } catch (e) {}
  const text = stripTags(note);
  let excerpt = text.substr(0, Math.min(excerptLen, text.length));
  if (excerpt.length !== text.length) excerpt += '...';
  return excerpt;
}

function stripTags(html) {
  if (!html) return '';
  const div = document.createElement("div");
  div.innerHTML = html.replace('><', '> <').replace('  ', ' ');
  return div.textContent || div.innerText || "";
}

function sortNotesByTitle(notes) {
  return notes.sort(compareNoteTitles);
}

function compareNoteTitles( a, b ) {
  if ( a.title < b.title ){
    return -1;
  }
  if ( a.title > b.title ){
    return 1;
  }
  return 0;
}
